import(/* webpackMode: "eager" */ "/codebuild/output/src1774888044/src/pubgen-app/next-app/app/global-error.tsx");
